import React from "react";
import { Card, Form, Button, Space, Alert, Typography } from "antd";
import ReactQuill from "react-quill";

import useUpdate from "hooks/useUpdate";

import useFormErrors from "hooks/useFormErrors";
import { useParams } from "react-router-dom";
import { useIssueKinds } from "context/providers/issue_kinds";
import QuestionMarkTooltip from "components/QuestionMarkTooltip";

const default_danger_info = `
  <p><strong>!!! UWAGA !!!</strong></p>

  <p><strong>Zgrywanie zapisu monitoringu</strong> jest to usługa płatna, ustalana indywidualnie. Cena usługi jest uzależniona od długości zapisu.</p>
  <p>Zainteresowane osoby proszę o wypełnienie formularza zgrań zapisu monitoringu oraz udostępnienie swojego nośnika danych (pendrive) maksymalnie 120 GB.</p>
  <p>Formularz zgrań zapisu monitoringu dostępny jest w administracji budynku.</p>
  <p>Osoba zainteresowana, która nie posiada swojego nośnika danych (pendrive) może skorzystać z wypożyczenia krótkoterminowego nośnika danych uiszczając uprzednio kaucję w wysokości 100 zł za jeden nośnik danych w administracji budynku.</p>
`;

const DangerInfo = () => {
  const [form] = Form.useForm();
  const { id } = useParams();
  const { data, refetch } = useIssueKinds();
  const issue_kind = data.find((item) => item.id === id);

  const path = `/issue_kinds/${id}`;
  const { is_saving, update } = useUpdate({
    path,
    form,
    onSuccess: refetch,
  });
  const { has_error, onFieldsChange } = useFormErrors();

  const danger_info = issue_kind?.danger_info || "";

  return (
    <Form
      form={form}
      layout="vertical"
      onFieldsChange={onFieldsChange}
      initialValues={{
        danger_info,
      }}
      onFinish={(values) => update(values)}
    >
      {(values) => {
        const dirty = values.danger_info !== danger_info;
        const is_to_many_characters = (values.danger_info?.length || 0) > 1000;
        return (
          <Card
            styles={{
              body: {
                padding: "10px 24px 0",
              },
            }}
            title={
              <>
                Opis ostrzegawczy{" "}
                <QuestionMarkTooltip text="Informacja wyświetlana na stronie formularza w czerwonym panelu." />
              </>
            }
            extra={
              <Button
                disabled={!dirty || has_error}
                loading={is_saving}
                type="primary"
                htmlType="submit"
              >
                Zapisz
              </Button>
            }
          >
            {dirty && (
              <Alert
                message="UWAGA! Zapisz zmiany przed wyjściem!"
                banner
                style={{ marginBottom: 20 }}
              />
            )}
            <Form.Item
              name="danger_info"
              rules={[
                () => ({
                  validator(_, value) {
                    const text = value.replace(/<[^>]*>/g, "");
                    const has_any_letter = /[a-zA-Z0-9]/.test(text);

                    if (text.length > 0 && !has_any_letter) {
                      return Promise.reject(
                        new Error("Pole tekstowe nie zawiera znaków.")
                      );
                    }
                    return Promise.resolve();
                  },
                }),
              ]}
            >
              <ReactQuill
                value={values.danger_info}
                onChange={(val, _, __, { getLength }) => {
                  form.setFieldValue("danger_info", getLength() > 1 ? val : "");
                }}
                modules={{
                  toolbar: [
                    ["bold", "italic"],
                    [{ list: "ordered" }, { list: "bullet" }],
                  ],
                }}
              />
              <p className="counter-info">
                <Typography.Text
                  type={is_to_many_characters ? "danger" : "secondary"}
                >
                  {values.danger_info?.length || 0} / 1000
                </Typography.Text>
              </p>
            </Form.Item>
            <Space style={{ marginBottom: 20 }}>
              <Button
                type="primary"
                htmlType="button"
                size="small"
                onClick={() => {
                  form.setFieldValue("danger_info", default_danger_info);
                  form.validateFields(["danger_info"]);
                }}
              >
                Wypełnij przykładowym tekstem
              </Button>
              <Button
                type="primary"
                htmlType="button"
                size="small"
                onClick={() => {
                  form.setFieldValue("danger_info", "");
                  form.validateFields(["danger_info"]);
                }}
              >
                Wyczysć tekst
              </Button>
            </Space>
          </Card>
        );
      }}
    </Form>
  );
};

export default DangerInfo;
